import React, { useState, useEffect } from 'react';

import './Devices.assign.scss';
import gqlSchemaLibrary from '../services/graphql.schemas';
import {useLazyQuery, useMutation} from '@apollo/client';
import Button from '../forms/buttons/Button';
import {getDateFormat} from "../utils/date";
import {PatientAvatar} from "../visuals/Patient.avatar";
import {useTranslation} from "react-i18next";
import ButtonIcon from "../forms/buttons/Button.icon";
import AuditTrail, {PAGES} from "../services/interactions/audit.trail";

function DevicesBaseUnAssign({ currentOrg, deviceToAssign, onClose, onSucces }) {
    const {t} = useTranslation(['devices','common','users']);
    const [confirmed, setConfirmed] = useState(false);
    const [patient, setPatient] = useState(null);
    const [onAction, setOnAction] = useState(false);

    useEffect(() => {
        fetchPerson({
            variables: {
                personId: deviceToAssign.patientId
            }
        });
    }, [deviceToAssign])

    const [unAssigningPeripheralToPatient] = useMutation(gqlSchemaLibrary.devices.peripherial.mutation.unAssignPeripheralToPatient, {
        onCompleted: ({ data }) => {
            setConfirmed(true);
            setOnAction(false);
            onSucces();
        },
        onError: (error) => {
            setOnAction(false);
        }
    });

    const [fetchPerson] = useLazyQuery(gqlSchemaLibrary.patients.queries.getPerson, {
        onCompleted: (data) => {
            setPatient(data.getPerson);
        },
        fetchPolicy: 'cache-and-network'
    });

    const onUnnAssign = () => {
        if (onAction) {
            return;
        }
        AuditTrail.sendLog(PAGES.DEVICE_TYPE_LIST, {tag: 'button', event: 'onClick', action: 'button modal un assigned device'});
        unAssigningPeripheralToPatient({
            variables: {
                deviceId: deviceToAssign.deviceId
            }
        })
        setOnAction(true);
    }

    const _onClose = () => {
        AuditTrail.sendLog(PAGES.DEVICE_TYPE_LIST, {tag: 'modal', event: 'closeModal', action: 'button modal cancel un assigned device'});
        onClose();
    }

    const onButtonAction = () => {
        if (!confirmed) {
            onUnnAssign();
        } else {
            _onClose();
        }
    }

    return (
        <div id="DevicesBaseAssign">
            <div className="_deviceInfo">
                <h3>{t('devices:unassign-capitalize')} the {deviceToAssign.deviceSubtype} ID: {deviceToAssign.deviceId} from:</h3>
            </div>
            {
                patient?
                    <div className="_confirmation">
                        <div className="__KitAssignBody">
                            <div className="__KitAssignBodyPatientBio">
                                <div className="_BioDisplay">
                                    <PatientAvatar bio={patient.user.bio} small={true} />
                                    <div className="__BioDisplayName">
                                        <h3>
                                            {patient.user.bio.lastname}, {patient.user.bio.firstname}
                                        </h3>
                                        <div className="__BioDisplayData">
                                            <p>
                                                {patient.user.bio.gender}
                                            </p>
                                            <p className="centered">
                                                {Math.floor((Date.now() - patient.dateOfBirth) / (1000 * 60 * 60 * 24 * 365))} {t('users:yo')}
                                                </p>
                                            <p>
                                                {t('users:dob')} {getDateFormat(currentOrg, patient.dateOfBirth, 'short')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : ''
            }
            <div className={`_success ${confirmed ? 'confirmed' : ''}`}>
                <div className="_successContainer">
                    <div className="_icon">
                        <ButtonIcon className="success" size={46}>
                            <i className="material-icons">
                                check
                            </i>
                        </ButtonIcon>
                    </div>
                    <h3>
                        { deviceToAssign.deviceId }
                    </h3>
                    <h3 className="msg">{t('devices:successully-unassigned')}</h3>
                </div>
            </div>
            <div className="_actions">
                <Button className="tertiary" handleClick={_onClose}>
                    {confirmed ? t('common:close') : t('common:cancel')}
                </Button>
                <Button className="primary" handleClick={onButtonAction} disabled={!patient || onAction}>
                    {confirmed ? t('common:finish') : t('devices:unassign-capitalize')}
                </Button>
            </div>
        </div>
    )
}

export default DevicesBaseUnAssign;
